const BROWSER_NETWORK_ERROR_MESSAGES = [
	'Failed to fetch',
	'Load failed',
	'NetworkError when attempting to fetch resource.',
	'network error',
	'Error in input stream',
];

const MODULE_FETCH_ERROR_PREFIX = 'Failed to fetch dynamically imported module: ';

const hasBrowserNetworkErrorSignature = (error: unknown): boolean => {
	if (!error || typeof error !== 'object') {
		return false;
	}
	if (!('name' in error) || error.name !== 'TypeError') {
		return false;
	}
	const message = 'message' in error ? error.message : undefined;

	return (
		typeof message === 'string' &&
		(BROWSER_NETWORK_ERROR_MESSAGES.includes(message) ||
			message.startsWith(MODULE_FETCH_ERROR_PREFIX))
	);
};

export const isBrowserNetworkError = (error: unknown): boolean =>
	hasBrowserNetworkErrorSignature(error) ||
	(!!error &&
		typeof error === 'object' &&
		'cause' in error &&
		hasBrowserNetworkErrorSignature(error.cause));
